module.exports = __webpack_public_path__ + "img/Phone_05.0a3911ac.jpg";